module.exports = __webpack_public_path__ + "static/media/city.cd8791c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/city.png
// module id = 127
// module chunks = 0